module.exports = __webpack_public_path__ + "img/support_c7.bc69e9af.png";